import type {AsyncNamespace, OttoNexus} from "@otto-ec/global-resources/nexus";
import type {SharingRaw} from './sharing'
import type {GlobalRaw} from './global';
import type {PushNotificationsRaw} from './pushnotifications';
import type {CookieBannerRaw} from './cookiebanner';
import type {HapticFeedbackRaw} from './hapticfeedback';
import type {ThirdpartyTrackingRaw} from './thirdpartytracking';
import type {UserMediaRaw} from './usermedia';
import type { MediaRaw } from './media';
import type {NavigationBarsRaw} from './navigationbars';
import type {WebviewRaw} from "./webview";

declare global {
    interface NexusInterfaces {
        /**
 *
 */
        apps: {
            cookieBanner: AsyncNamespace<CookieBannerRaw>
            global: AsyncNamespace<GlobalRaw>,
            hapticFeedback: AsyncNamespace<HapticFeedbackRaw>,
            userMedia: AsyncNamespace<UserMediaRaw>,
            webview: AsyncNamespace<WebviewRaw>,
            pushNotifications: AsyncNamespace<PushNotificationsRaw>,
            sharing: AsyncNamespace<SharingRaw>,
            thirdpartyTracking: AsyncNamespace<ThirdpartyTrackingRaw>,
            media: AsyncNamespace<MediaRaw>,
            navigationBars: AsyncNamespace<NavigationBarsRaw>
        }
    }
}

export type apps = OttoNexus["apps"]

export const apps: OttoNexus["apps"] = otto.apps

export { APPS_MODULES, esiIncludePath, esiIncludeTag, npmSubpath } from "./moduleRegistry.js";
export type { AppsModuleName, ModuleDescriptor } from "./moduleRegistry.js";
